import { maisIntegridade, mapa, sisbi } from "../../assets/images";
import Footer from "../../components/footer";
import {
  BoxImageContainer,
  BoxImageMaisIntegridade,
  BoxImageMapa,
  BoxImageSisbi,
  BoxTextContainer,
  ButtonContatos,
  ContatosESelosContainer,
  HomeContainer,
  InfoCard,
  InfoContainerUm,
  InfoText,
  InfoTitle,
} from "./styles";

const PrivacyPolicies = () => {
  return (
    <HomeContainer>
      <InfoContainerUm>
        <InfoCard>
          <InfoTitle>Política de Privacidade</InfoTitle>
          <InfoText>
            AA Suprema Charque valoriza a transparência e o respeito aos seus
            usuários. Esta Política de Privacidade tem o objetivo de informar
            como tratamos os dados pessoais coletados durante a navegação em
            nosso site.
          </InfoText>
        </InfoCard>

        <InfoCard>
          <InfoTitle>Coleta de Informações</InfoTitle>
          <InfoText>
            Nosso site pode coletar informações de forma automática por meio de
            cookies, que são pequenos arquivos armazenados no seu navegador.
            Eles servem para melhorar a experiência de navegação, facilitar o
            uso do site e oferecer conteúdos mais relevantes para você.
          </InfoText>
        </InfoCard>

        <InfoCard>
          <InfoTitle>Uso dos Cookies</InfoTitle>
          <InfoText>
            Os cookies utilizados pela Suprema Charque têm como finalidade:
            <br />
            <br />
            • Tornar a navegação mais rápida e prática;
            <br />
            • Memorizar preferências e configurações do usuário;
            <br />
            • Analisar de forma anônima o uso do site, ajudando a aprimorar
            continuamente nossos serviços.
            <br />
            <br />
            Você pode, a qualquer momento, configurar seu navegador para
            bloquear ou excluir cookies. No entanto, algumas funcionalidades do
            site podem não operar corretamente sem eles.
          </InfoText>
        </InfoCard>

        <InfoCard>
          <InfoTitle>Proteção de Dados</InfoTitle>
          <InfoText>
            A Suprema Charque não compartilha, vende ou aluga informações
            pessoais de seus usuários a terceiros. Todos os dados coletados são
            utilizados exclusivamente para os fins descritos nesta Política.
          </InfoText>
        </InfoCard>

        <InfoCard>
          <InfoTitle>Alterações nesta Política</InfoTitle>
          <InfoText>
            Podemos atualizar esta Política de Privacidade sempre que
            necessário, para garantir maior clareza e conformidade com a
            legislação vigente. Recomendamos que você a consulte periodicamente.
          </InfoText>
        </InfoCard>

        <InfoCard>
          <InfoTitle>Contato</InfoTitle>
          <InfoText>
            Se tiver dúvidas sobre esta Política ou sobre o uso de cookies,
            entre em contato conosco pelos canais disponíveis em nosso site.
          </InfoText>
        </InfoCard>
      </InfoContainerUm>

      <ContatosESelosContainer>
        <BoxTextContainer>
          <div>
            <h2>Vamos fazer negócios?</h2>
            <p>Fale com um especialista</p>
          </div>
          <ButtonContatos
            onClick={() => {
              window.location.href = "/contact-us";
            }}
          >
            CONTATO
          </ButtonContatos>
        </BoxTextContainer>
        <BoxImageContainer>
          <BoxImageSisbi src={sisbi} alt="SISBI" />
          <BoxImageMaisIntegridade src={maisIntegridade} />
          <BoxImageMapa src={mapa} alt="Mapa" />
        </BoxImageContainer>
      </ContatosESelosContainer>
      <Footer />
    </HomeContainer>
  );
};
export default PrivacyPolicies;
